<template>
    <v-row>
        <v-col lg="10" md="11" sm="11" cols="12" class="py-2 mx-auto">
            <h1 class="font-weight-bold my-0 py-0">Cool stays.</h1>
            <p class="pb-15">The best unique, stylish places to stay including cottages, tiny homes, container homes, treehouses and beyond!</p>
            <modal-details :show="dialogDetails" :item="selectedItem" />
            <v-row id="container" v-if="items.length">
                <v-col
                    v-for="(item) in items"
                    :key="item.name"
                    :cols="(12/itemsPerRow)"
                    class="pa-4"
                  > 
                    <v-sheet min-height="272" class="fill-height" color="transparent">
                        <v-lazy 
                            v-model="item.isActive" :options="{threshold: .5}"
                            class="fill-height">
                            <v-card class="card fill-height d-flex flex-column">
                              <v-img 
                                v-if="item.ImgThumb"
                                min-height="170" 
                                max-height="170"
                                :src="item.ImgThumb[0].url" 
                                @click="openDialog(item)"
                                class="contrast">
                                <div class="d-flex align-center pa-3">
                                    <v-tooltip right color="black">
                                        <template v-slot:activator="{ on }">
                                            <v-chip small color="primary" v-on="on">{{ item.State }}</v-chip>
                                        </template>
                                        <span>{{ item.City }}, {{ item.State }}</span>
                                    </v-tooltip>
                                </div>
                              </v-img>
                              <v-card-title>
                                  <h5 class="font-weight-light text-truncate" :title="item.Short">
                                    <span v-text="item.Name"></span> 
                                  </h5>
                              </v-card-title>
                              <v-card-text class="mb-0 pb-0 d-none">
                                <div v-html="item.Short" class="mr-2"></div>
                              </v-card-text>
                              <v-card-text class="mt-auto d-flex align-center">
                                <v-chip small class="mr-1" v-for="t in item.TagNames" v-text="t" :key="t"></v-chip>
                                <v-btn icon small @click="openDialog(item)" class="shrink ml-auto">
                                    <v-icon large color="black">mdi-home-circle</v-icon>
                                </v-btn>
                                <v-btn icon small target="_blank" :href="item.URL" class="shrink ml-1">
                                    <v-icon large color="primary">mdi-home-circle-outline</v-icon>
                                </v-btn>
                              </v-card-text>
                            </v-card>
                        </v-lazy>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { GET_RESOURCES } from '@/store/action-types'
import { TOGGLE_DIALOG_DETAILS } from '@/store/mutation-types'
import ModalDetails from '@/components/ModalDetails'

export default {
    components: {
        ModalDetails
    },
    data() {
        return {
            items: [],
            page: 1,
            busy: false,
            dialog: false,
            selectedItem: {},
        }
    },
    computed: {
        ...mapState({
            resources: state => state.resource.all,
            dialogDetails: state => state.resource.dialogDetails,
            // activeResource: state => state.resource.resource,
            // loading: state => state.user.isLoading
        }),
        visibleItems () {
            return this.items.filter(p=>p.isActive).length
        },
        itemsPerRow () {
            console.log(this.$vuetify.breakpoint.name)
            let ss = null
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    ss = 1
                    break
                case 'sm': 
                    ss = 2
                    break
                case 'md': 
                    ss = 3
                    break
                case 'lg': 
                    ss = 4
                    break
                default:
                    ss = 2
                    break
            }
            return ss
        }
    },
    methods: {
        async getResources() {
            await this.$store.dispatch(GET_RESOURCES)
            console.log(this.resources)
                this.items = this.resources
        },
        openDialog(item) {
            // console.log(item)
            this.selectedItem = { ...item }
            console.log('selectedItem', this.selectedItem)
            // this.dialog = !this.dialog
            this.$store.commit(TOGGLE_DIALOG_DETAILS, !this.dialogDetails)
        },
    },
    mounted() {
        this.getResources()
    },
}
</script>